import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './BrandOnboardingConnectSocialsPanel.scss';

import { updateBrand } from '../../../Actions/BrandActions';
import { updateBrandOnboardingObject } from '../../../Actions/OnboardingActions';
import { setUIAuthRedirectUrl, openConnectInstagramModal } from '../../../Actions/UIActions';
import { getBrandSocialAccount } from '../../../Helpers/user_helpers';
import { openInstagramAuthModal } from '../../../Helpers/social_helpers';

import { ReactComponent as InstagramIcon } from '../../../static/images/social_icons/instagram.svg';
import FacebookSDK from '../../General/FacebookSDK';
import { ConnectInstagramWarningModal } from '../../Application/CreatorApplicationLinkSocials';
import BrandOnboardingProgressBar from '../BrandOnboardingProgressBar';
import Tooltip from '../../General/Tooltip';

const BrandOnboardingConnectSocialsPanel = props => {
  const { user } = props;
  const connectedInstagram = getBrandSocialAccount(user, 'instagram');

  const [instagramModalVisible, setInstagramModalVisible] = useState(false);
  const [isAddingSocialAccount, setIsAddingSocialAccount] = useState(false);
  const onNextClick = async skip => {
    if (props.isLoading) return;
    else if (!skip && !connectedInstagram?.id) return window.ALERT.warn('Please connect your Instagram account before proceeding.');
    else if (isAddingSocialAccount) return window.ALERT.error('Please wait for the current connection to finish.');

    if (skip) await props.updateBrandOnboardingObject({ skipConnectingSocials: true });
    props.goToNextPanel();
  };
  const close = () => setInstagramModalVisible(false);

  const connectInstagram = () => {
    props.setUIAuthRedirectUrl(
      `/onboarding/brand?section=${props.activeSectionName.split(' ').join('+')}&panel=${props.activePanelName.split(' ').join('+')}`
    );
    if (connectedInstagram?.id) return window.ALERT.warn('You have already connected your Instagram account.');
    else if (isAddingSocialAccount) return window.ALERT.error('Please wait for the current connection to finish.');
    else {
      openInstagramAuthModal(
        async authResponse => {
          setIsAddingSocialAccount(true);
          await props.connectInstagram(authResponse);
          setIsAddingSocialAccount(false);
        },
        () => props.openConnectInstagramModal()
      );
    }
  };

  return (
    <div className='brand-onboarding-connect-socials-panel-outer'>
      <FacebookSDK />
      <ConnectInstagramWarningModal connectInstagram={connectInstagram} close={close} instagramModalVisible={instagramModalVisible} />
      <div className='brand-onboarding-connect-socials-panel-inner'>
        <div className='brand-onboarding-split-container-outer'>
          <div className='brand-onboarding-split-container-inner'>
            <div className='brand-onboarding-graphic-container-outer'>
              <div className='brand-onboarding-graphic-container-inner'>
                <div className='brand-onboarding-graphic-container-stat'>
                  <div className='brand-onboarding-graphic-container-stat-label'>Our Numbers</div>
                  <div className='brand-onboarding-graphic-container-stat-number'>{props.featuredStat.number}+</div>
                  <div className='brand-onboarding-graphic-container-stat-description'>{props.featuredStat.description}</div>
                </div>

                <BrandOnboardingProgressBar
                  goToPanel={props.goToPanel}
                  sections={props.sections}
                  activeSectionName={props.activeSectionName}
                  activePanelName={props.activePanelName}
                />
              </div>

              <div className='brand-onboarding-graphic-background'>
                <img className='brand-onboarding-graphic-background-image' src={props.backgroundImage} alt='name panel graphic' />
                <div className='brand-onboarding-graphic-background-overlay'></div>
              </div>
            </div>

            <div className='brand-onboarding-input-container-outer'>
              <div className='brand-onboarding-input-container-number-marker'>{props.panelNumber}</div>

              <div className={cn('brand-onboarding-input-container-inner', { isLoading: props.isLoading })}>
                <div className='brand-onboarding-title-text'>Connect your instagram</div>
                <div className='brand-onboarding-subtitle-text'>
                  Connecting your Instagram helps us find creators who tag and share your brand, and provides more accurate analytics.
                </div>

                <div className='brand-onboarding-connect-socials-panel-link-socials-buttons'>
                  <button
                    className='brand-onboarding-connect-socials-panel-link-socials-button primary'
                    onClick={() => setInstagramModalVisible(true)}
                    disabled={!!connectedInstagram?.id}
                  >
                    <InstagramIcon className='brand-onboarding-connect-socials-panel-link-socials-button-icon' /> Connect
                    {connectedInstagram?.id ? 'ed' : ''}
                  </button>
                </div>

                <div className='brand-onboarding-pagination-buttons'>
                  <button className='brand-onboarding-button stretch' onClick={() => props.goToPreviousPanel()}>
                    Back
                  </button>
                  <button
                    className={cn('brand-onboarding-button stretch primary', { disabled: !connectedInstagram?.id })}
                    onClick={() => onNextClick()}
                  >
                    Next
                  </button>
                </div>
                {!connectedInstagram?.id && (
                  <Tooltip text='You can connect your social accounts later in your account settings'>
                    <button className='brand-onboarding-skip-panel-button' onClick={() => onNextClick(true)}>
                      Skip for now
                    </button>
                  </Tooltip>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

BrandOnboardingConnectSocialsPanel.propTypes = {
  user: PropTypes.object.isRequired,

  goToPreviousPanel: PropTypes.func.isRequired,
  goToNextPanel: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  const { user } = state;
  return { user };
};

export default connect(mapStateToProps, {
  updateBrand,
  updateBrandOnboardingObject,
  setUIAuthRedirectUrl,
  openConnectInstagramModal
})(withRouter(BrandOnboardingConnectSocialsPanel));
